import { useLayoutEffect } from "react";
import { useMenuDrawerContext } from "../components/menu/MenuDrawerContextProvider.shared";

export const useFocusedNavigation = (disabled?: boolean) => {
  const { setDisplayTypeOverride } = useMenuDrawerContext();

  useLayoutEffect(() => {
    if (disabled) {
      return;
    }
    setDisplayTypeOverride("hidden");
    return () => {
      setDisplayTypeOverride(undefined);
    };
  }, [disabled, setDisplayTypeOverride]);
};
